export default function NoResults({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="232"
      height="200"
      viewBox="0 0 232 200"
      fill="none"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <g clipPath="url(#clip0_3371_39908)">
        <path
          d="M67.1306 119.45C96.2581 119.45 119.871 95.8372 119.871 66.7097C119.871 37.5822 96.2581 13.9697 67.1306 13.9697C38.0031 13.9697 14.3906 37.5822 14.3906 66.7097C14.3906 95.8372 38.0031 119.45 67.1306 119.45Z"
          fill="#F0F2F7"
        />
        <path
          d="M83.6109 45.1699H50.6609C49.0317 45.1699 47.7109 46.4907 47.7109 48.1199C47.7109 49.7492 49.0317 51.0699 50.6609 51.0699H83.6109C85.2402 51.0699 86.5609 49.7492 86.5609 48.1199C86.5609 46.4907 85.2402 45.1699 83.6109 45.1699Z"
          fill="#D0D7EB"
        />
        <path
          d="M69.0191 64.6504H36.0691C34.4399 64.6504 33.1191 65.9711 33.1191 67.6004C33.1191 69.2296 34.4399 70.5504 36.0691 70.5504H69.0191C70.6484 70.5504 71.9691 69.2296 71.9691 67.6004C71.9691 65.9711 70.6484 64.6504 69.0191 64.6504Z"
          fill="#D0D7EB"
        />
        <path
          d="M88.4391 84.1299H55.4891C53.8598 84.1299 52.5391 85.4506 52.5391 87.0799C52.5391 88.7091 53.8598 90.0299 55.4891 90.0299H88.4391C90.0683 90.0299 91.3891 88.7091 91.3891 87.0799C91.3891 85.4506 90.0683 84.1299 88.4391 84.1299Z"
          fill="#D0D7EB"
        />
        <path
          d="M73.6699 132.01C58.2399 133.56 43.4999 129.62 31.4199 121.77"
          stroke="#425B9F"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M15.7697 107.57C10.2197 100.61 6.03969 92.4602 3.67969 83.4902"
          stroke="#8FA1D2"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M1.5 66.5899C1.51 46.0599 11.14 27.2999 26.49 15.1699"
          stroke="#425B9F"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M74.6094 1.5C85.1494 2.7 95.0294 6.43 103.549 12.12"
          stroke="#425B9F"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M117.211 24.2803C121.861 29.7603 125.651 36.0403 128.321 42.9203"
          stroke="#8FA1D2"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M131.821 80.8301C129.711 91.7801 124.791 102.29 117.061 111.22"
          stroke="#425B9F"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M228.729 186.09L191.769 150.34C189.519 148.17 186.279 147.57 183.469 148.52L176.869 142.13C187.069 130.8 192.659 116.46 192.659 101.29C192.659 84.6498 185.959 69.0098 173.799 57.2498C161.639 45.4898 145.469 39.0098 128.269 39.0098C111.069 39.0098 94.8991 45.4898 82.7391 57.2498C57.6391 81.5398 57.6391 121.05 82.7391 145.34C94.8991 157.1 111.069 163.58 128.269 163.58C144.509 163.58 159.829 157.79 171.729 147.24L178.069 153.38C176.759 156.22 177.309 159.67 179.719 162L216.679 197.75C219.799 200.77 224.869 200.77 227.999 197.75L228.729 197.04C231.849 194.02 231.849 189.12 228.729 186.09ZM128.279 154.67C114.159 154.67 100.039 149.46 89.2591 139.03C67.7091 118.18 67.7091 84.3798 89.2591 63.5298C100.029 53.1098 114.159 47.8898 128.279 47.8898C142.399 47.8898 156.519 53.0998 167.299 63.5298C188.849 84.3798 188.849 118.18 167.299 139.03C156.529 149.45 142.399 154.67 128.279 154.67Z"
          fill="#3BBAE3"
        />
      </g>
      <defs>
        <clipPath id="clip0_3371_39908">
          <rect width="231.07" height="200.01" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
